import styled from 'styled-components';
import tw from 'twin.macro';

export const QuizContainer = styled.div`
  .course-title {
    ${tw`text-primary text-center`}
    font-weight: 600;
    font-size: 15px;
    line-height: 19px;
    margin-bottom: 27px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  button {
    ${tw`focus:outline-none text-base font-semibold py-2`}
    width: 204px;

    &.retake {
      ${tw`bg-red`}
      &.success {
        ${tw`bg-light-yellow`}
      }
    }
  }
`;
